import request from "@/utils/Request";

const fileUtils = {

  /**
   * 加载文件
   * @param path
   */
  load(filePath){
    return request({
      url: '/appointment-manager/fastdfs/load',
      params:{
        path: filePath
      },
      responseType: 'arraybuffer'
    });
  },
}
export default fileUtils;
